import {flow, getEnv, getType, resolveIdentifier, types} from "mobx-state-tree";
import {GroupSelectState} from "../../elements/groups/GroupSelectState";
import Notification from "../../../utils/Notification";
import {DefaultSettingModel} from "../../../models/defaultSetting/DefaultSettingModel";
import {DimensionSelectViewState} from "../../elements/dimensions/dimensionSelectViewState";
import {UtmSelectState} from "../../elements/utms/UtmSelectState";
import {QrConfigSelectState} from "../../elements/qrconfig/QrConfigSelectState";
import {ParameterSetSelectState} from "../../elements/parameterSets/ParameterSetSelectState";
import {CodeTypeSelectState} from "../../elements/codeTypes/CodeTypeSelectState";
import CodeType from "../../../models/CodeType";
import lodash from "lodash";
import {ExtendedDataSetSelectState} from "../../extendedData/ExtendedDataSetSelectState";


export const DefaultSettingFormState = types.model("DefaultSettingFormState", {
  defaultSetting: types.maybe(DefaultSettingModel),
  isLoading: types.optional(types.boolean, false),
  groupSelectStore: types.maybe(types.reference(GroupSelectState)),
  dimensionSelectViewState: types.maybe(types.late(() => types.reference(DimensionSelectViewState))),
  utmSelectState : types.maybe(types.reference(UtmSelectState)),
  qrConfigSelectState: types.maybe(types.reference(QrConfigSelectState)),
  parameterSetSelectState: types.maybe(types.reference(ParameterSetSelectState)),
  codeTypeSelectStore: types.maybe(types.late(() => types.reference(CodeTypeSelectState))),
  extendedDataSetSelectStore: types.maybe(types.reference(ExtendedDataSetSelectState)),
  isEnabled: types.optional(types.boolean, false),
})
  .actions(self => ({
    setOnSelectChanges() {
      self.groupSelectStore?.setMultiSelectConsumer(self.selectGroup)
      self.dimensionSelectViewState?.dimensionSelectStates?.map(dimensionSelectStore => dimensionSelectStore?.setMultiSelectConsumer(self.setSelectedDimension))
      self.utmSelectState?.setConsumer(self.consumeUtmSelect)
      self.parameterSetSelectState?.setConsumer(self.selectParameterSet)
      self.qrConfigSelectState?.setConsumer(self.selectDesignerConfig)
      self.codeTypeSelectStore?.setMultiSelectConsumer(self.selectCodeType)
      self.extendedDataSetSelectStore?.setConsumer(self.selectExtendedDataSet)
    },
    selectGroup(obj) {
      obj = obj || []
      if (obj.length == 1){
        self.utmSelectState.store.setFilterOn(obj[0]?.uuid)
        self.qrConfigSelectState?.setSelectedGroup(obj[0]?.uuid)
        self.parameterSetSelectState.store.setFilterOn(obj[0]?.uuid)
        self.extendedDataSetSelectStore?.store?.setFilterOn((item) => {
          return (item.owner.groupUuid === obj[0]?.uuid || item?.isExclusivelyGroupOwned === false);
        });
        // self.dimensionSelectViewState?.getListOnGroup(obj[0]?.uuid)
      }
      else {
        self.utmSelectState.store.setFilterOn(obj?.uuid)
        self.qrConfigSelectState?.store?.setFilterOn(obj?.uuid)
        self.parameterSetSelectState.store.setFilterOn(obj?.uuid)
        self.extendedDataSetSelectStore.store.setFilterOn(obj?.uuid)
        // self.dimensionSelectViewState?.getListOnGroup(obj?.uuid)
      }
      const groupUuids = self?.groupSelectStore?.selectedGroups.map((group) => group.uuid)
      self?.defaultSetting?.updateGroups(groupUuids)
    },
    setSelectedDimension(obj){
      const dimensionMapping = self?.dimensionSelectViewState?.dimensionSelectStates?.reduce(
        (acc, dimensionSelectStore) => {
          const selectedUUIDs = dimensionSelectStore.selectedDimensions?.map((dimension) => { //change to selected Dimensions
            return dimension.uuid;
          });
          // if (selectedUUIDs?.length > 0) {
          //   acc[dimensionSelectStore.selectStateUuid] = selectedUUIDs;
          // }
          acc[dimensionSelectStore.selectStateUuid] = selectedUUIDs || [];
          return acc;
        },
        {}
      );
      self?.defaultSetting?.updateDimensions(dimensionMapping)
    },
    consumeUtmSelect(obj) {
      self?.defaultSetting?.updateUTM(obj)
    },
    selectParameterSet(obj){
      self?.defaultSetting?.updateParameterSet(obj)
    },
    selectDesignerConfig(obj){
      self?.defaultSetting?.updateDesignerConfig(obj)
    },
    selectCodeType(obj){
      const types = obj?.map(d => {
       return  d.name
      }) || [];
      self?.defaultSetting?.updateTypes(types)
      self?.checkExperienceType()
    },
    selectExtendedDataSet(obj){
        self?.defaultSetting?.updateExtendedDataSet(obj)
    },
    validateForm() {
      let isValid = true;
      isValid = self?.defaultSetting?.validateDefaultSettingModel() // validate fields other than name
      if (self.utmSelectState?.selected === undefined && self.qrConfigSelectState?.selectedConfig === undefined && self.parameterSetSelectState?.selected === undefined  && self.extendedDataSetSelectStore?.selected === undefined) {
        isValid=false
      }
      return isValid;
    },
    handleHasErrors(boolean) {
      self.formHasErrors = boolean;
    },
    handleErrorMessage(message) {
      self.errorMessage = message;
    },
    hydrateForm(item){
      self.isLoading = true;
      try {
        self.defaultSetting.name = item?.name;
        self.name = item?.name;
        self.groupSelectStore?.setSelectedGroup(item?.groups);
        self.qrConfigSelectState?.setSelectedConfig(item?.designerConfig);
        self.utmSelectState?.setSelectedUtm(item?.utm);
        self.parameterSetSelectState?.setSelectedParameterSet(item?.parametersets)
        self.dimensionSelectViewState?.hydrateDimensions(item?.dimensions);
        self.codeTypeSelectStore?.select(item?.types);
        self.extendedDataSetSelectStore?.setSelectedExtendedData(item?.extendedDataSet);
        // self.defaultSetting.hydrateDefaultSetting(item,self)
      } catch (err) {
        console.error(`${getType(self).name} Error: Failed to populate fields to view`, err);
      }
      self.isLoading = false;
    },
    checkExperienceType(){
      const requiredTypes = ['url', 'gs1'];

      self.isEnabled = ! self.codeTypeSelectStore?.selectedCodeTypes?.some(ct =>
        requiredTypes.includes(ct.name)
      );
      if(self.codeTypeSelectStore?.selectedCodeTypes?.length === 0 || self.codeTypeSelectStore?.selectedCodeTypes === undefined){
        self.isEnabled = ! true
      }

    },
    addDefaultSetting: flow(function* f() {
      if(self?.validateForm()) {
      self.isLoading = true
      try {
        if(!self.defaultSetting?.dimensions){
          console.log("Empty")
          self.setSelectedDimension()
        }
        const manager = getEnv(self).defaultSettingManager
        const resp = yield manager.create(self);
        return resp;
      } catch (err) {
        new Notification()
          .setType("error")
          .setMessage(`${self?.defaultSetting?.name} Default Setting failed creating`)
          .send();
      }
      self.isLoading = false
      }
      else {
        new Notification()
          .setType("error")
          .setMessage(`At least one of the Code Settings must be present.`)
          .send();
      }
    }),
    updateDefaultSetting: flow(function* f(id) {
      if(self?.validateForm()) {
        self.isLoading = true
        try {
        const manager = getEnv(self).defaultSettingManager
        const resp = yield manager.update(self,id);
        return resp;
        } catch (err) {
          new Notification()
            .setType("error")
            .setMessage(`${self?.defaultSetting?.name} Default Setting failed updating`)
            .send();
        }
        self.isLoading = false
      } else {
        new Notification()
          .setType("error")
          .setMessage(`At least one of the Code Settings must be present.`)
          .send();
      }
    }),
    fetchModelAndHydrate: flow(function* (id){
      if (!id) {
        console.warn(`${getType(self).name} Warn: ID is 'undefined' or 'null'`);
      }
      let response;
      self.isLoading = true;
      self?.setOnSelectChanges();
      try {
        response = yield getEnv(self).defaultSettingManager.getDefaultSetting(id);
        if (response) {
          self.hydrateForm(response);
          self.handleHasErrors(false);
        } else {
          self.handleHasErrors(true);
        }
      } catch (e) {
        console.error(`${getType(self).name} Error: Failed to Fetch and Hydrate data for '${id}'`, e);
      }
      self.isLoading = false;
      return response;
    }),

  })).views((self) => ({}))
